import React from 'react';
import './details.css';

function Details() {
  return (
    <section className="info-bubbles">
    <div className="bubble left dress">
      <img src="/images/bubble.svg" alt="" className="bubble-bg" />
      <div className="bubble-text">
        <p className='header'>Дресс-код</p>
        <p>
          <b>Cocktail.</b><br />
          В приглушенных природных оттенках.<br />
          Пожалуйста, исключите оттенки белого и красного цветов.
        </p>
      </div>
    </div>
  
    <div className="bubble right hotel">
      <img src="/images/bubble.svg" alt="" className="bubble-bg"/>
      <div className="bubble-text">
        <p className='header'>Отель</p>
        <p>
        <b>Просим приехать к 15:00!</b>
        Свадьба будет в отеле с ночевкой и завтраком.
        Церемония и вечеринка — на лужайке.
        Возьмите удобную обувь для танцев.
        </p>
      </div>
    </div>
  
    <div className="bubble left alco">
      <img src="/images/bubble.svg" alt="" className="bubble-bg"/>
      <div className="bubble-text">
        <p className='header'>Алкоголь</p>
        <p>
          На вечеринке будет много разного алкоголя.<br />
          Но если вы захотите что-то иное, то у бассейна будет платный бар!
        </p>
      </div>
    </div>
  
    <div className="bubble right car">
      <img src="/images/bubble.svg" alt="" className="bubble-bg"/>
      <div className="bubble-text">
        <p className='header'>Трансфер</p>
        <p>
        Будет трансфер из Тбилиси и обратно на следующий день.<br />
        Можно добраться и самостоятельно.<br />
        Детали в Telegram-канале, всех добавим.<br />
        </p>
      </div>
    </div>
  </section>
  );
}

export default Details;